"use client";

import { activateConsentScripts } from "@/lib/consent/activate-consent-scripts";
import { readStoredConsent } from "@/lib/consent/storage";

function tryOpenGreipChat() {
  window.GreipChat?.open?.();
}

export function openGreipSupportWidget() {
  tryOpenGreipChat();
  if (typeof window.GreipChat?.open === "function") {
    return;
  }

  const stored = readStoredConsent();
  if (!stored?.choices?.preferences) {
    return;
  }

  activateConsentScripts(stored.choices);
  window.setTimeout(tryOpenGreipChat, 400);
  window.setTimeout(tryOpenGreipChat, 1200);
}
